import { useState } from "react";

export interface UseHorizontalAccordion {
  isOpen: boolean;
  onToggle: () => void;
}

interface Props {
  onChange?: (isOpen: boolean) => void;
}

export const useHorizontalAccordion = (
  props?: Props
): UseHorizontalAccordion => {
  const { onChange } = props || {};
  const [isOpen, setIsOpen] = useState(true);

  const onToggle = () => {
    setIsOpen((prev) => !prev);
    if (onChange) {
      onChange(!isOpen);
    }
  };

  return {
    isOpen,
    onToggle,
  };
};
